import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import { GET_PREFERENCE } from "../services/get-preference";
import { UPDATE_PREFERENCE } from "../services/update-preference";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../common_components/mdae-framework";
export const TOGGLE_DASHBOARD_SETTING_POPUP = "TOGGLE_DASHBOARD_SETTING_POPUP";
export const CHANGE_CHARTYPE = "CHANGE_CHARTYPE";
export const TOGGLE_EADASHBOARD_WIDGET_ACTION_POPOVER =
  "TOGGLE_EADASHBOARD_WIDGET_ACTION_POPOVER";
export const RERENDER_DASHBOARD_WIDGET_CHARTS =
  "RERENDER_DASHBOARD_WIDGET_CHARTS";
export const DASHBOARD_WIDGET_PRINT_ACTION = "DASHBOARD_WIDGET_PRINT_ACTION";
export const DASHBOARD_WIDGET_PDF_FILE_ACTION =
  "DASHBOARD_WIDGET_PDF_FILE_ACTION";
export const DASHBOARD_WIDGET_PNG_FILE_ACTION =
  "DASHBOARD_WIDGET_PNG_FILE_ACTION";
export const DASHBOARD_WIDGET_PROPERTIES_ACTION =
  "DASHBOARD_WIDGET_PROPERTIES_ACTION";
export const SET_MY_TASK_DASHBOARD_WIDGET_PROPERTIES_DATA =
  "SET_MY_TASK_DASHBOARD_WIDGET_PROPERTIES_DATA";
export const TOGGLE_UPDATE_DASHBOARD_WIDGET_PROPERTIES =
  "TOGGLE_UPDATE_DASHBOARD_WIDGET_PROPERTIES";

export const ALL = {
    reviewContractorId: 0,
    reviewerDescription: 'All',
};

export const ALLSEQUENCE = {
    sequenceNo: 0,
    sequenceName: 'All',
};

export const PERIOD = {
    THIRTY_DAYS: 'Last 30 Days',
    NINTY_DAYS: 'Last 90 Days',
    SIX_MONTHS: 'Last 6 Months',
    TWELEVE_MONTHS: 'Last 12 Months'
}
export const timePeriod = [{ id: 1, name: PERIOD.THIRTY_DAYS, period: 30 },
{ id: 2, name: PERIOD.NINTY_DAYS, period: 90 },
{ id: 3, name: PERIOD.SIX_MONTHS, period: 6 },
{ id: 4, name: PERIOD.TWELEVE_MONTHS, period: 12 }]

const initialState = {
  isLoading: false,
  addedWidgetList: [],
  renderChartCount: 0,
  isUpdateDashboardWidgetProperties: false,
};
export const SET_MY_EA_AUDIT_BY_STATUS_DASHBOARD_WIDGET_PROPERTIES_DATA =
  "SET_MY_EA_AUDIT_BY_STATUS_DASHBOARD_WIDGET_PROPERTIES_DATA";
export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_UPDATE_DASHBOARD_WIDGET_PROPERTIES:
      return {
        ...state,
        isUpdateDashboardWidgetProperties: !state.isUpdateDashboardWidgetProperties,
      };
    case TOGGLE_EADASHBOARD_WIDGET_ACTION_POPOVER:
    case TOGGLE_DASHBOARD_SETTING_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case CHANGE_CHARTYPE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case RERENDER_DASHBOARD_WIDGET_CHARTS:
      newState = cloneDeep(state);
      newState = { ...newState, renderChartCount: state.renderChartCount + 1 };
      return newState;
    case DASHBOARD_WIDGET_PRINT_ACTION:
      newState = cloneDeep(state);
      newState = { ...newState, ...action.data };
      return newState;
    case DASHBOARD_WIDGET_PDF_FILE_ACTION:
      newState = cloneDeep(state);
      newState = { ...newState, ...action.data };
      return newState;
    case DASHBOARD_WIDGET_PNG_FILE_ACTION:
      newState = cloneDeep(state);
      newState = { ...newState, ...action.data };
      return newState;
    case SET_MY_TASK_DASHBOARD_WIDGET_PROPERTIES_DATA:
      newState = cloneDeep(state);
      newState = {
        ...newState,
        myTaskWidgetPropertiesData: action.data,
      };
      return newState;
    case SET_MY_EA_AUDIT_BY_STATUS_DASHBOARD_WIDGET_PROPERTIES_DATA:
      newState = cloneDeep(state);
      newState = {
        ...newState,
        myExternalAuditByStatusPropertiesData: action.data,
      };
      return newState;
    case DASHBOARD_WIDGET_PROPERTIES_ACTION:
      newState = cloneDeep(state);
      newState = { ...newState, ...action.data };
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_PREFERENCE)(action)) {
        return { ...state };
      }
      if (isAsyncComplete(GET_PREFERENCE)(action)) {
        const response = action.response;
        return {
          ...state,
          addedWidgetList:
            JSON.parse(response.settings) != null
              ? JSON.parse(response.settings)
              : [],
        };
      }
      return state;
    default:
      return state;
  }
}
